export class User {
  constructor(
    public name: string,
    public avatar: string,
    public username: string,
    public sex: string,
    public birthDate: number,
    public weight: number,
    public height: number,
    public _id: string,
    public referralCode: string,
    public updatedAt: string,
    public createdAt: string,
    public email?: string
  ) {}

  static fromJSON(json: UserJSON | string): User {
    if (typeof json === 'string') {
      // if it's a string, parse it first
      return JSON.parse(json, User.reviver);
    } else {
      // create an instance of the User class
      const user = Object.create(User.prototype);
      // copy all the fields from the json object
      return Object.assign(user, json);
    }
  }

  static reviver(key: string, value: any): any {
    return key === '' ? User.fromJSON(value) : value;
  }
}

export interface UserJSON {
  name: string;
  avatar: string;
  username: string;
  sex: string;
  birthDate: number;
  weight: number;
  height: number;
  _id: string;
  referralCode: string;
  updatedAt: string;
  createdAt: string;
}
